/* ==========================================================================
   MELTY — JavaScript del tema (vanilla, nessuna dipendenza)
   Carrello: Shopify AJAX Cart API + Section Rendering API.
   ========================================================================== */
(function () {
  'use strict';

  var M = window.Melty || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function announce(msg) {
    var live = document.getElementById('LiveRegion');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 40);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ---------- formattazione prezzi (formato del negozio) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || M.moneyFormat || '€{{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  M.formatMoney = formatMoney;

  /* ======================================================================
     OVERLAY (menu mobile, carrello, ricerca, lightbox) con focus trap
     ====================================================================== */
  var stack = [];
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function lockScroll(on) {
    if (on) {
      var sb = window.innerWidth - document.documentElement.clientWidth;
      if (sb > 0) document.body.style.paddingRight = sb + 'px';
      document.body.classList.add('is-locked');
    } else {
      document.body.classList.remove('is-locked');
      document.body.style.paddingRight = '';
    }
  }

  function openOverlay(el, focusEl) {
    if (!el || stack.some(function (s) { return s.el === el; })) return;
    stack.push({ el: el, ret: document.activeElement });
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    $$('[aria-controls="' + el.id + '"][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    lockScroll(true);
    document.dispatchEvent(new CustomEvent('overlay:change'));
    setTimeout(function () {
      var f = focusEl || el.querySelector('[autofocus]') || el.querySelector('input[type="search"]') || $$(FOCUSABLE, el).filter(function (n) { return n.offsetParent !== null; })[0];
      if (f) f.focus({ preventScroll: true });
    }, 60);
  }

  function closeOverlay(el, opts) {
    var idx = -1;
    stack.forEach(function (s, i) { if (s.el === el) idx = i; });
    if (idx === -1) return;
    var item = stack.splice(idx, 1)[0];
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + el.id + '"][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!stack.length) lockScroll(false);
    document.dispatchEvent(new CustomEvent('overlay:change'));
    if (el.id === 'CartDrawer') { var msg = $('[data-added-msg]', el); if (msg) msg.innerHTML = ''; }
    var ret = item.ret && item.ret !== document.body && document.body.contains(item.ret) ? item.ret : null;
    if (!(opts && opts.noFocus) && ret && ret.focus) ret.focus({ preventScroll: true });
  }
  M.openOverlay = function (id) { openOverlay(document.getElementById(id)); };
  M.closeOverlay = function (id) { closeOverlay(document.getElementById(id)); };

  function initOverlays() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open]');
      if (opener) {
        var target = document.getElementById(opener.getAttribute('data-open'));
        if (target) { e.preventDefault(); openOverlay(target); return; }
      }
      var closer = e.target.closest('[data-close]');
      if (closer) {
        var host = closer.closest('[data-overlay]');
        if (host) closeOverlay(host, { noFocus: closer.tagName === 'A' });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!stack.length) return;
      var top = stack[stack.length - 1].el;
      if (e.key === 'Escape') { closeOverlay(top); return; }
      if (e.key !== 'Tab') return;
      var f = $$(FOCUSABLE, top).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Theme Editor: apri il carrello quando la sezione viene selezionata
    document.addEventListener('shopify:section:select', function (e) {
      var drawer = e.target.querySelector('#CartDrawer');
      if (drawer) openOverlay(drawer);
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var drawer = e.target.querySelector('#CartDrawer');
      if (drawer) closeOverlay(drawer, { noFocus: true });
    });
  }

  /* ======================================================================
     HEADER + BARRA ANNUNCI
     ====================================================================== */
  var headerReady = false;
  function initHeader() {
    if (headerReady) return;
    headerReady = true;
    var header = $('[data-header]');
    if (header) {
      var update = function () { header.classList.toggle('is-stuck', window.scrollY > 24); };
      window.addEventListener('scroll', update, { passive: true });
      update();
    }
    $$('[data-announce]').forEach(function (bar) {
      var msgs = $$('.announce__msg', bar);
      if (msgs.length < 2) return;
      var i = 0;
      var ms = (parseInt(bar.getAttribute('data-interval'), 10) || 4) * 1000;
      if (reduceMotion) return;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, ms);
    });
  }

  /* ======================================================================
     CARRELLO — Shopify AJAX API
     ====================================================================== */
  var Cart = {
    busy: false,

    sectionIds: function () {
      var ids = [];
      if ($('[data-cart-drawer]')) ids.push('cart-drawer');
      $$('[data-cart-page]').forEach(function (el) { ids.push(el.getAttribute('data-section-id')); });
      return ids;
    },

    request: function (url, body) {
      body.sections = this.sectionIds().join(',');
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            var err = new Error(data.description || data.message || M.strings.error);
            err.data = data;
            throw err;
          }
          return data;
        });
      });
    },

    setBusy: function (on) {
      this.busy = on;
      document.documentElement.classList.toggle('cart-is-busy', on);
    },

    renderSections: function (sections) {
      if (!sections) return;
      var parser = new DOMParser();
      if (sections['cart-drawer']) {
        var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        var drawer = $('[data-cart-drawer]');
        if (drawer) {
          ['[data-cart-body]', '[data-cart-foot]'].forEach(function (sel) {
            var fresh = $(sel, doc), old = $(sel, drawer);
            if (!fresh || !old) return;
            var keepMsg = sel === '[data-cart-body]' ? $('[data-added-msg]', old) : null;
            old.innerHTML = fresh.innerHTML;
            old.hidden = fresh.hidden;
            if (keepMsg) { var slot = $('[data-added-msg]', old); if (slot) slot.replaceWith(keepMsg); }
          });
        }
      }
      $$('[data-cart-page]').forEach(function (el) {
        var id = el.getAttribute('data-section-id');
        if (!sections[id]) return;
        var doc = parser.parseFromString(sections[id], 'text/html');
        var fresh = $('[data-cart-page]', doc);
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
    },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (b) {
        b.textContent = count;
        b.classList.toggle('is-on', count > 0);
      });
      var toggle = document.getElementById('CartToggle');
      if (toggle) {
        toggle.setAttribute('aria-label', toggle.getAttribute('aria-label').replace(/\d+/, count));
        toggle.classList.remove('bump');
        void toggle.offsetWidth;
        toggle.classList.add('bump');
      }
    },

    refreshCount: function () {
      return fetch(M.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.updateCount(cart.item_count); return cart; });
    },

    add: function (items, opts) {
      opts = opts || {};
      var self = this;
      self.setBusy(true);
      return self.request(M.routes.cartAdd + '.js', { items: items })
        .then(function (data) {
          self.renderSections(data.sections);
          return self.refreshCount();
        })
        .then(function () {
          var drawer = document.getElementById('CartDrawer');
          if (drawer) {
            var slot = $('[data-added-msg]', drawer);
            if (slot) slot.innerHTML = '<p class="added"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>' + M.strings.added + '</p>';
            openOverlay(drawer);
          } else if (M.cartType === 'page' || opts.redirect) {
            window.location.href = M.routes.cart;
          }
          announce(M.strings.added);
        })
        .finally(function () { self.setBusy(false); });
    },

    change: function (line, quantity) {
      var self = this;
      self.setBusy(true);
      return self.request(M.routes.cartChange + '.js', { line: line, quantity: quantity })
        .then(function (cart) {
          self.renderSections(cart.sections);
          self.updateCount(cart.item_count);
          return cart;
        })
        .finally(function () { self.setBusy(false); });
    },

    note: debounce(function (value) {
      fetch(M.routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      });
    }, 500)
  };
  M.Cart = Cart;

  function flashButton(btn) {
    if (!btn) return;
    var label = btn.querySelector('.btn__label');
    if (!label) return;
    var original = label.textContent;
    label.textContent = M.strings.added;
    btn.classList.add('is-done');
    setTimeout(function () { btn.classList.remove('is-done'); label.textContent = original; }, 1600);
  }

  function showFormError(form, msg) {
    var el = form && form.querySelector('[data-form-error]');
    if (el) { el.textContent = msg; el.hidden = false; }
    else announce(msg);
  }

  function initCart() {
    // Invio dei form "aggiungi al carrello" (pagina prodotto, card, ecc.)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;
      var submitter = e.submitter;
      if (submitter && submitter.hasAttribute('data-buy-now')) return; // invio nativo → checkout
      if (M.cartType === 'page' || !document.getElementById('CartDrawer')) return; // invio nativo → /cart
      e.preventDefault();
      var btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
      var errEl = form.querySelector('[data-form-error]');
      if (errEl) errEl.hidden = true;
      var fd = new FormData(form);
      var id = fd.get('id');
      var qty = parseInt(fd.get('quantity') || '1', 10);
      var item = { id: parseInt(id, 10), quantity: qty };
      var props = {};
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
      if (Object.keys(props).length) item.properties = props;
      var sp = fd.get('selling_plan');
      if (sp) item.selling_plan = sp;
      if (btn) btn.classList.add('is-loading');
      Cart.add([item])
        .then(function () { flashButton(btn); })
        .catch(function (err) { showFormError(form, err.message); })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    });

    // Aggiunta rapida (suggerimento nel carrello, sezioni colore e set)
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-quick-add]');
      if (!q) return;
      e.preventDefault();
      var id = parseInt(q.getAttribute('data-quick-add'), 10);
      var qty = parseInt(q.getAttribute('data-quantity') || '1', 10);
      if (!id) return;
      q.classList.add('is-loading');
      Cart.add([{ id: id, quantity: qty }], { redirect: true })
        .then(function () { flashButton(q); })
        .catch(function (err) {
          announce(err.message);
          var l = q.querySelector('.btn__label') || q;
          var prev = l.textContent;
          l.textContent = err.message;
          setTimeout(function () { l.textContent = prev; }, 2600);
        })
        .finally(function () { q.classList.remove('is-loading'); });
    });

    // Quantità / rimozione righe (drawer e pagina carrello)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change], [data-remove]');
      if (!btn) return;
      var line = btn.closest('[data-line]');
      if (!line || Cart.busy) return;
      var input = line.querySelector('[data-line-qty]');
      var current = parseInt(input.value, 10) || 0;
      var next = btn.hasAttribute('data-remove') ? 0 : current + parseInt(btn.getAttribute('data-qty-change'), 10);
      var max = input.getAttribute('max');
      if (max && next > parseInt(max, 10)) next = parseInt(max, 10);
      changeLine(line, Math.max(0, next));
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-line-qty]')) {
        var line = e.target.closest('[data-line]');
        changeLine(line, Math.max(0, parseInt(e.target.value, 10) || 0));
      }
      if (e.target.matches('[data-cart-note]')) Cart.note(e.target.value);
    });
    document.addEventListener('input', function (e) {
      if (e.target.matches('[data-cart-note]')) Cart.note(e.target.value);
    });
  }

  function changeLine(lineEl, qty) {
    var index = parseInt(lineEl.getAttribute('data-line'), 10);
    var key = lineEl.getAttribute('data-key');
    Cart.change(index, qty)
      .then(function () {
        if (qty === 0) { announce(M.strings.removed); return; }
        var again = document.querySelector('[data-key="' + key + '"] [data-line-qty]');
        if (again && parseInt(again.value, 10) < qty) {
          var err = again.closest('[data-line]').querySelector('[data-line-error]');
          if (err) { err.textContent = M.strings.error; err.hidden = false; }
        }
      })
      .catch(function (err) {
        var e = lineEl.querySelector('[data-line-error]');
        if (e) { e.textContent = err.message; e.hidden = false; }
      });
  }

  /* ======================================================================
     QUANTITÀ (stepper)
     ====================================================================== */
  function initSteppers() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-stepper] [data-step]');
      if (!b) return;
      var input = b.closest('[data-stepper]').querySelector('input');
      var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
      var min = parseInt(input.min || '1', 10), max = parseInt(input.max || '99', 10);
      input.value = Math.min(max, Math.max(min, v));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ======================================================================
     PRODOTTO: varianti, prezzo, disponibilità, URL, galleria
     ====================================================================== */
  if (!customElements.get('product-info')) {
    customElements.define('product-info', class extends HTMLElement {
      connectedCallback() {
        var json = this.querySelector('[data-product-json]');
        if (!json) return;
        this.product = JSON.parse(json.textContent);
        var notesEl = this.querySelector('[data-variant-notes]');
        this.notes = notesEl ? JSON.parse(notesEl.textContent || '{}') : {};
        this.section = this.getAttribute('data-section');
        this.updateUrl = this.getAttribute('data-update-url') === 'true';
        this.addEventListener('change', this.onChange.bind(this));
        this.variant = this.currentVariant();
        this.paintNote(false);
        this.markAvailability();
      }

      selectedOptions() {
        return $$('[data-variant-picker] fieldset', this).map(function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }

      currentVariant() {
        var input = this.querySelector('[data-variant-input]');
        var id = input ? parseInt(input.value, 10) : null;
        var found = this.product.variants.filter(function (v) { return v.id === id; })[0];
        return found || this.product.variants[0];
      }

      findVariant(opts) {
        return this.product.variants.filter(function (v) {
          return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
        })[0];
      }

      onChange(e) {
        if (!e.target.matches('[data-option-index]')) return;
        var opts = this.selectedOptions();
        var v = this.findVariant(opts);
        $$('[data-option-value]', this).forEach(function (el) {
          el.textContent = opts[parseInt(el.getAttribute('data-option-value'), 10)] || '';
        });
        this.variant = v || null;
        this.render();
        this.markAvailability();
        this.paintNote(true);
      }

      markAvailability() {
        var self = this;
        var opts = this.selectedOptions();
        $$('[data-option-index]', this).forEach(function (input) {
          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          var test = opts.slice(); test[idx] = input.value;
          var match = self.product.variants.filter(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          })[0];
          input.closest('label').classList.toggle('is-unavailable', !match || !match.available);
        });
      }

      paintNote(animate) {
        var el = this.querySelector('[data-variant-note]');
        if (!el) return;
        var self = this;
        var text = '';
        this.selectedOptions().forEach(function (o) { if (o && self.notes[o]) text = self.notes[o]; });
        if (!animate || reduceMotion) { el.textContent = text; el.hidden = !text; return; }
        el.classList.add('is-fading');
        setTimeout(function () { el.textContent = text; el.hidden = !text; el.classList.remove('is-fading'); }, 180);
      }

      render() {
        var v = this.variant;
        var input = this.querySelector('[data-variant-input]');
        var addBtn = this.querySelector('[data-add-button]');
        var addLabel = this.querySelector('[data-add-label]');
        var buyNow = this.querySelector('[data-buy-now]');
        var holder = this.querySelector('[data-add-text]');
        var addText = holder ? holder.getAttribute('data-add-text') : M.strings.addToCart;

        if (input && v) input.value = v.id;

        // prezzo
        var priceWrap = this.querySelector('[data-block-price] [data-price-wrap]');
        if (priceWrap && v) {
          $('[data-price]', priceWrap).textContent = formatMoney(v.price);
          var cmp = $('[data-compare]', priceWrap), disc = $('[data-discount]', priceWrap);
          if (v.compare_at_price > v.price) {
            cmp.innerHTML = '<span class="sr-only">' + (cmp.querySelector('.sr-only') ? cmp.querySelector('.sr-only').textContent : '') + '</span>' + formatMoney(v.compare_at_price);
            cmp.hidden = false;
            if (disc) { disc.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; disc.hidden = false; }
          } else {
            cmp.hidden = true;
            if (disc) disc.hidden = true;
          }
        }
        var bp = this.querySelector('[data-button-price]');
        if (bp && v) bp.textContent = formatMoney(v.price);

        // pulsanti
        var available = !!(v && v.available);
        if (addBtn) addBtn.disabled = !available;
        if (buyNow) buyNow.disabled = !available;
        if (addLabel) addLabel.textContent = !v ? M.strings.unavailable : (available ? addText : M.strings.soldOut);

        // disponibilità
        var stockWrap = this.querySelector('[data-inventory]');
        if (stockWrap) {
          var stock = $('[data-stock]', stockWrap);
          var low = parseInt(stockWrap.getAttribute('data-low'), 10) || 5;
          stock.className = 'stock';
          if (!available) { stock.classList.add('stock--out'); stock.textContent = v ? M.strings.soldOut : M.strings.unavailable; }
          else if (v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
            stock.classList.add('stock--low');
            stock.textContent = M.strings.lowStock.replace('[count]', v.inventory_quantity);
          } else { stock.textContent = M.strings.inStock; }
        }

        if (!v) return;

        // URL
        if (this.updateUrl) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }

        // galleria
        var gallery = document.querySelector('product-gallery[data-section="' + this.section + '"]');
        if (gallery && v.featured_media && gallery.goToMedia) gallery.goToMedia(v.featured_media);

        // barra d'acquisto
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { section: this.section, variant: v } }));
      }
    });
  }

  /* ---------- galleria ---------- */
  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = $$('.gallery__slide', this.track);
        this.thumbs = $$('[data-thumb]', this);
        this.count = this.querySelector('[data-count]');
        this.index = 0;
        var self = this;

        this.thumbs.forEach(function (t) {
          t.addEventListener('click', function () { self.go(parseInt(t.getAttribute('data-thumb'), 10)); });
        });
        var prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1); });

        this.track.addEventListener('scroll', debounce(function () {
          var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
          if (i !== self.index) self.setActive(i);
        }, 60), { passive: true });

        this.track.addEventListener('click', function (e) {
          var z = e.target.closest('[data-zoom]');
          if (!z) return;
          var imgs = $$('[data-zoom] img', self.track);
          Lightbox.open(imgs, imgs.indexOf(z.querySelector('img')));
        });

        // Parti dall'immagine della variante selezionata
        var startId = this.closest('.product__grid') && this.closest('.product__grid').querySelector('[data-variant-input]');
        if (startId) {
          var info = this.closest('.product__grid').querySelector('product-info');
          if (info && info.variant && info.variant.featured_media) this.goToMedia(info.variant.featured_media, true);
        }
      }

      go(i, instant) {
        if (!this.slides.length) return;
        i = (i + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.track.clientWidth * i, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
        this.setActive(i);
      }

      setActive(i) {
        this.index = i;
        this.thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
        if (this.count) this.count.textContent = (i + 1) + ' / ' + this.slides.length;
      }

      goToMedia(mediaId, instant) {
        var idx = -1;
        this.slides.forEach(function (s, i) { if (String(s.getAttribute('data-media-id')) === String(mediaId)) idx = i; });
        if (idx > -1) this.go(idx, instant);
      }
    });
  }

  /* ---------- lightbox ---------- */
  var Lightbox = {
    el: null, imgs: [], i: 0,
    init: function () {
      this.el = document.getElementById('Lightbox');
      if (!this.el) return;
      var self = this;
      $('[data-lb-prev]', this.el).addEventListener('click', function () { self.step(-1); });
      $('[data-lb-next]', this.el).addEventListener('click', function () { self.step(1); });
      document.addEventListener('keydown', function (e) {
        if (!self.el.classList.contains('is-open')) return;
        if (e.key === 'ArrowLeft') self.step(-1);
        if (e.key === 'ArrowRight') self.step(1);
      });
      var x0 = null;
      var fig = $('figure', this.el);
      fig.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      fig.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) self.step(dx < 0 ? 1 : -1);
      }, { passive: true });
    },
    open: function (imgs, i) {
      if (!this.el || !imgs.length) return;
      this.imgs = imgs; this.i = Math.max(0, i);
      this.paint();
      var multi = imgs.length > 1;
      $('[data-lb-prev]', this.el).hidden = !multi;
      $('[data-lb-next]', this.el).hidden = !multi;
      openOverlay(this.el, $('[data-lb-next]', this.el));
    },
    step: function (d) { this.i = (this.i + d + this.imgs.length) % this.imgs.length; this.paint(); },
    paint: function () {
      var src = this.imgs[this.i];
      var img = $('img', this.el);
      img.src = src.getAttribute('data-full') || src.currentSrc || src.src;
      img.alt = src.alt;
      $('figcaption', this.el).textContent = (this.i + 1) + ' / ' + this.imgs.length;
    }
  };

  /* ---------- barra d'acquisto fissa ---------- */
  function initBuybar() {
    var bar = $('[data-buybar]');
    if (!bar) return;
    var target = document.getElementById(bar.getAttribute('data-target'));
    var form = target && target.querySelector('form[data-type="add-to-cart-form"]');
    var on = false;
    function update() {
      if (!target) return;
      var r = target.getBoundingClientRect();
      var footer = $('.footer');
      var nearEnd = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = r.bottom < 0 && !nearEnd && !stack.length;
      if (show === on) return;
      on = show;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', String(!show));
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('overlay:change', update);
    update();

    $('[data-buybar-add]', bar).addEventListener('click', function () {
      if (form) {
        if (form.requestSubmit) form.requestSubmit(form.querySelector('[name="add"]'));
        else form.querySelector('[name="add"]').click();
      }
    });
    document.addEventListener('variant:change', function (e) {
      var v = e.detail.variant;
      var p = $('[data-buybar-price]', bar), n = $('[data-buybar-variant]', bar), img = $('[data-buybar-img]', bar);
      if (p) p.textContent = formatMoney(v.price);
      if (n) n.textContent = v.title;
      if (img && v.image) img.src = v.image;
      $('[data-buybar-add]', bar).disabled = !v.available;
    });
  }

  /* ======================================================================
     SEZIONI: colori e set
     ====================================================================== */
  function initColourPickers() {
    $$('[data-colour-picker]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      var cta = $('[data-colour-cta]', sec);
      var label = cta && $('.btn__label', cta);
      var prefix = cta ? cta.getAttribute('data-prefix') : '';
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-colour-variant]');
        if (!b) return;
        $$('[data-colour-variant]', sec).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        if (cta) {
          cta.setAttribute('data-quick-add', b.getAttribute('data-colour-variant'));
          cta.disabled = b.getAttribute('data-available') !== 'true';
          if (label) label.textContent = prefix + ' ' + b.getAttribute('data-colour-name');
        }
        var img = b.getAttribute('data-image');
        var media = $('[data-colour-media] img', sec);
        if (img && media) { media.removeAttribute('srcset'); media.src = img; }
      });
    });
  }

  var bundlesReady = false;
  function initBundles() {
    $$('[data-bundles]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      var btn = $('[data-bundle-add]', sec);
      var priceEl = $('[data-bundle-price]', sec);
      var nameEl = $('[data-bundle-colour-name]', sec);
      function sync() {
        var tier = $('input[name="' + sec.id + '-tier"]:checked', sec);
        var colour = $('input[name="' + sec.id + '-colour"]:checked', sec);
        if (!btn || !tier) return;
        var qty = tier.value;
        btn.setAttribute('data-quantity', qty);
        if (colour) {
          btn.setAttribute('data-quick-add', colour.value);
          btn.disabled = colour.getAttribute('data-available') !== 'true';
          if (nameEl) nameEl.textContent = colour.getAttribute('data-name');
        }
        if (priceEl) priceEl.textContent = tier.getAttribute('data-price-label');
        var label = $('.btn__label', btn);
        if (label) label.textContent = parseInt(qty, 10) > 1 ? btn.getAttribute('data-label-set') : btn.getAttribute('data-label-one');
      }
      sec.addEventListener('change', sync);
      sync();
    });
    if (bundlesReady) return;
    bundlesReady = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-bundle-pick]');
      if (!a) return;
      var input = document.querySelector('[data-bundles] input[value="' + a.getAttribute('data-bundle-pick') + '"][name$="-tier"]');
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }

  /* ======================================================================
     ACCORDION (FAQ, tab) — animazione morbida su <details>
     ====================================================================== */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('details.acc > summary');
      if (!summary) return;
      var details = summary.parentElement;
      var body = details.querySelector('.acc__body');
      if (!body || reduceMotion) return;
      e.preventDefault();
      var group = details.closest('[data-acc-single]');
      if (!details.open) {
        if (group) $$('details.acc[open]', group).forEach(function (d) { if (d !== details) collapse(d); });
        details.open = true;
        var h = body.scrollHeight;
        body.style.height = '0px';
        requestAnimationFrame(function () {
          body.style.transition = 'height .38s cubic-bezier(.22,.68,.25,1)';
          body.style.height = h + 'px';
        });
        body.addEventListener('transitionend', function done() { body.style.height = ''; body.style.transition = ''; body.removeEventListener('transitionend', done); });
      } else {
        collapse(details);
      }
    });
    function collapse(details) {
      var body = details.querySelector('.acc__body');
      body.style.height = body.scrollHeight + 'px';
      requestAnimationFrame(function () {
        body.style.transition = 'height .32s cubic-bezier(.22,.68,.25,1)';
        body.style.height = '0px';
      });
      body.addEventListener('transitionend', function done() {
        details.open = false; body.style.height = ''; body.style.transition = '';
        body.removeEventListener('transitionend', done);
      });
    }
    if (/^#faq-/.test(window.location.hash)) {
      var d = document.getElementById(window.location.hash.slice(1));
      if (d && d.tagName === 'DETAILS') d.open = true;
    }
  }

  /* ======================================================================
     RICERCA ISTANTANEA (Shopify Predictive Search API)
     ====================================================================== */
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-results]');
        if (!this.input || !this.results) return;
        this.cache = {};
        this.input.addEventListener('input', debounce(this.onInput.bind(this), 250));
        this.input.addEventListener('keydown', this.onKey.bind(this));
      }
      onInput() {
        var q = this.input.value.trim();
        if (!q) { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
        if (this.cache[q]) { this.paint(this.cache[q]); return; }
        var self = this;
        var url = M.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
        if (this.ctrl) this.ctrl.abort();
        this.ctrl = new AbortController();
        fetch(url, { signal: this.ctrl.signal })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#shopify-section-predictive-search');
            var out = inner ? inner.innerHTML : '';
            self.cache[q] = out;
            self.paint(out);
          })
          .catch(function (err) { if (err.name !== 'AbortError') self.results.innerHTML = ''; });
      }
      paint(html) {
        this.results.innerHTML = html;
        this.input.setAttribute('aria-expanded', html ? 'true' : 'false');
      }
      onKey(e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var links = $$('a', this.results);
        if (!links.length) return;
        e.preventDefault();
        var i = links.indexOf(document.activeElement);
        i = e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : Math.max(0, i - 1);
        links[i].focus();
      }
    });
  }

  /* ======================================================================
     COLLEZIONE: filtri e ordinamento (Shopify Storefront Filtering)
     ====================================================================== */
  function initFacets() {
    $$('[data-facets-form]').forEach(function (form) {
      var submit = debounce(function () {
        var params = new URLSearchParams(new FormData(form));
        Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
        window.location.search = params.toString();
      }, 400);
      form.addEventListener('change', submit);
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-sort-select]')) return;
      var f = document.querySelector('form[data-facets-form]');
      var mirror = f && f.querySelector('[data-sort-mirror]');
      if (mirror) { mirror.value = e.target.value; f.dispatchEvent(new Event('change')); return; }
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', e.target.value);
      window.location.href = u.toString();
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-facets-toggle]');
      if (!t) return;
      var wrap = t.closest('.facets');
      var open = wrap.classList.toggle('is-open');
      t.setAttribute('aria-expanded', String(open));
    });
  }

  /* ======================================================================
     ANIMAZIONI AL SCROLL
     ====================================================================== */
  function initReveal(root) {
    var els = $$('.reveal:not(.in)', root);
    if (!document.body.classList.contains('has-reveal') || !('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }


  /* ======================================================================
     CONSENSO COOKIE — banner Melty + Customer Privacy API del negozio
     ====================================================================== */
  var Consent = {
    KEY: 'melty_consent_v1',
    api: null,
    init: function () {
      var self = this;
      this.el = document.getElementById('CookieConsent');
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-cookie-prefs]');
        if (t) { e.preventDefault(); self.open(true); }
      });
      if (!this.el) return;
      this.prefs = $('#ConsentPrefs', this.el);
      this.mainRow = $('[data-consent-main]', this.el);
      this.saveRow = $('[data-consent-save-row]', this.el);
      this.customizeBtn = $('[data-consent-customize]', this.el);
      $$('[data-consent-accept]', this.el).forEach(function (b) {
        b.addEventListener('click', function () { self.save({ analytics: true, marketing: true, preferences: true }); });
      });
      $('[data-consent-reject]', this.el).addEventListener('click', function () {
        self.save({ analytics: false, marketing: false, preferences: false });
      });
      $('[data-consent-save]', this.el).addEventListener('click', function () {
        var c = {};
        $$('[data-consent-key]', self.el).forEach(function (i) { c[i.getAttribute('data-consent-key')] = i.checked; });
        self.save(c);
      });
      this.customizeBtn.addEventListener('click', function () { self.expand(true); });

      this.loadApi(function (api) {
        self.api = api;
        if (self.needsDecision()) setTimeout(function () { self.show(false); }, 900);
      });
      window.MeltyConsent = { open: function () { self.open(true); } };
    },
    loadApi: function (cb) {
      var S = window.Shopify;
      if (S && S.customerPrivacy && S.customerPrivacy.setTrackingConsent) return cb(S.customerPrivacy);
      if (S && typeof S.loadFeatures === 'function') {
        try {
          S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
            cb(err || !window.Shopify.customerPrivacy ? null : window.Shopify.customerPrivacy);
          });
          return;
        } catch (e) { /* API non disponibile */ }
      }
      cb(null);
    },
    local: function () {
      try { return JSON.parse(localStorage.getItem(this.KEY) || 'null'); } catch (e) { return null; }
    },
    current: function () {
      if (this.api && this.api.currentVisitorConsent) {
        var c = this.api.currentVisitorConsent() || {};
        return { analytics: c.analytics === 'yes', marketing: c.marketing === 'yes', preferences: c.preferences === 'yes', decided: !!(c.analytics || c.marketing || c.preferences) };
      }
      var l = this.local();
      return l ? { analytics: !!l.analytics, marketing: !!l.marketing, preferences: !!l.preferences, decided: true } : { analytics: false, marketing: false, preferences: false, decided: false };
    },
    needsDecision: function () {
      // Se il visitatore ha già scelto (anche in passato), non mostriamo più il banner.
      return !this.current().decided;
    },
    fill: function () {
      var c = this.current();
      $$('[data-consent-key]', this.el).forEach(function (i) { i.checked = !!c[i.getAttribute('data-consent-key')]; });
    },
    expand: function (on) {
      this.fill();
      this.prefs.hidden = !on;
      this.mainRow.hidden = on;
      this.saveRow.hidden = !on;
      this.customizeBtn.setAttribute('aria-expanded', String(on));
      this.el.classList.toggle('is-expanded', on);
      if (on) { var f = $('[data-consent-key]', this.el); if (f) f.focus({ preventScroll: true }); }
    },
    show: function (expanded) {
      var el = this.el;
      el.hidden = false;
      this.expand(!!expanded);
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-visible'); }); });
    },
    open: function (expanded) {
      if (!this.el) return;
      var self = this;
      if (!this.api) this.loadApi(function (api) { self.api = api; self.show(expanded); });
      else this.show(expanded);
    },
    hide: function () {
      var el = this.el;
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, reduceMotion ? 0 : 420);
    },
    save: function (c) {
      var self = this;
      var data = { analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, date: new Date().toISOString() };
      try { localStorage.setItem(this.KEY, JSON.stringify(data)); } catch (e) { /* storage non disponibile */ }
      var done = function () {
        self.hide();
        announce(M.strings.consentSaved);
        document.dispatchEvent(new CustomEvent('melty:consent', { detail: data }));
      };
      if (this.api && this.api.setTrackingConsent) {
        try {
          this.api.setTrackingConsent({ analytics: data.analytics, marketing: data.marketing, preferences: data.preferences }, done);
        } catch (e) { done(); }
      } else {
        done();
      }
    }
  };

  /* ---------- micro-interazione al tocco/click ---------- */
  function initPressFeedback() {
    if (reduceMotion) return;
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest('.btn, .icon-btn, .swatch, .pill, .colourpick, .bundle__card, .thumb');
      if (!b) return;
      b.classList.add('is-pressed');
      var up = function () { b.classList.remove('is-pressed'); window.removeEventListener('pointerup', up); window.removeEventListener('pointercancel', up); };
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
    }, { passive: true });
  }

  /* ======================================================================
     AVVIO
     ====================================================================== */
  function init() {
    initOverlays();
    initHeader();
    initCart();
    initSteppers();
    Lightbox.init();
    initBuybar();
    initColourPickers();
    initBundles();
    initAccordions();
    initFacets();
    initReveal();
    Consent.init();
    initPressFeedback();

    document.addEventListener('shopify:section:load', function (e) {
      initReveal(e.target);
      initColourPickers();
      initBundles();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
